import { Fade } from "react-awesome-reveal";
import IntroSectionBadge from "../../../../components/intro-section-badge/intro-section-badge";
import CardDefault from "../../../../components/ui/cards/card-default/card-default";
import IconDescription from "../../../../components/ui/icon-description/icon-description";
import "./about-reliability.scss";

const AboutReliability = () => {
  return (
    <section className="about-reliability">
      <Fade direction="up" duration={900} triggerOnce>
        <div className="about-reliability__title">
          <IntroSectionBadge
            title={"Un Partner Affidabile"}
            text={
              "Dalla ditta artigiana alla attuale società, rimaniamo un punto di riferimento per le imprese di costruzioni e per gli studi tecnici che hanno scelto di averci come interlocutore serio, affidabile e competente."
            }
            bgColor={"light"}
            boxIcon="primary"
            icon="rocket"
          />
        </div>
      </Fade>

      <Fade
        cascade
        direction="up"
        duration={1000}
        delay={200}
        damping={0.2}
        triggerOnce
      >
        <div className="about-reliability__cards-list">
          <CardDefault type={"grey"} width="full-width" borderColor="#F9E7CC">
            <IconDescription
              icon={"user"}
              title={"Serio"}
              text={
                "Professionalità e integrità in ogni progetto e rapporto commerciale"
              }
              type={"secondary"}
              size={"medium"}
              direction="vertical"
            />
          </CardDefault>
          <CardDefault type={"grey"} width="full-width" borderColor="#F9E7CC">
            <IconDescription
              icon={"shield"}
              title={"Affidabile"}
              text={"Garanzia di risultati e rispetto dei tempi concordati"}
              type={"primary"}
              size={"medium"}
              direction="vertical"
            />
          </CardDefault>
          <CardDefault type={"grey"} width="full-width" borderColor="#F9E7CC">
            <IconDescription
              icon={"graduation"}
              title={"Competente"}
              text={"Expertise tecnica consolidata e aggiornamento continuo"}
              type={"secondary"}
              size={"medium"}
              direction="vertical"
            />
          </CardDefault>
        </div>
      </Fade>
    </section>
  );
};

export default AboutReliability;
